/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {

  class Pagination extends HTMLElement {

    constructor() {
      super();

      const id = this.dataset.section;

      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');

      this.animations_enabled =
        document.body.classList.contains('animations-true') &&
        typeof gsap !== 'undefined';

      this.i = 2;
      this.page_size = parseInt(this.dataset.pageSize);

      this.loadingProducts = false;
    }

    connectedCallback() {

      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }

      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }

    addUrlParam(search, key) {

      let newParam = key + '=' + this.i,
        params = '?' + newParam;

      if (search) {

        params = search.replace(
          new RegExp('([?&])' + key + '[^&]*'),
          '$1' + newParam
        );

        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }

    loadMore() {

      let base = this;

      this.button.addEventListener('click', function () {

        base.loadProducts();

        this.blur();

        return false;
      });
    }

    infinite() {

      let base = this;

      const checkAndLoad = () => {

        if (base.loadingProducts) return;

        if (base.classList.contains('pagination-ended')) return;

        const rect = base.getBoundingClientRect();

        // Load ONLY when loader enters viewport
        if (
          rect.top <= window.innerHeight &&
          rect.bottom >= 0
        ) {
          base.loadProducts();
        }
      };

      // Scroll listener
      window.addEventListener('scroll', checkAndLoad, {
        passive: true
      });

      // Resize listener
      window.addEventListener('resize', checkAndLoad);

      // Intersection observer
      base.observer = new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting) {
            checkAndLoad();
          }

        });

      }, {
        root: null,
        threshold: 0
      });

      base.observer.observe(base);

      // Initial check
      checkAndLoad();
    }

    async loadProducts() {

      let base = this;

      if (base.loadingProducts) return;

      if (base.classList.contains('pagination-ended')) return;

      base.loadingProducts = true;

      base.setAttribute('loading', true);

      const url =
        document.location.pathname +
        base.addUrlParam(document.location.search, 'page');

      base.i++;

      try {

        const response = await fetch(url);

        const responseText = await response.text();

        await base.renderProducts(responseText, url);

        dispatchCustomEvent('pagination:page-changed', {
          url: url
        });

      } catch (error) {

        console.error('Pagination Error:', error);

      } finally {

        requestAnimationFrame(() => {

          setTimeout(() => {

            base.loadingProducts = false;

            base.removeAttribute('loading');

            // Recheck only if loader visible
            const rect = base.getBoundingClientRect();

            if (
              rect.top <= window.innerHeight &&
              rect.bottom >= 0 &&
              !base.classList.contains('pagination-ended')
            ) {
              base.loadProducts();
            }

          }, 150);

        });
      }
    }

    async renderProducts(html, url) {

      let base = this;

      let grid_to_replace = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('product-grid');

      if (!grid_to_replace) {

        base.classList.add('pagination-ended');

        if (base.observer) {
          base.observer.disconnect();
        }

        if (base.button) {
          base.button.classList.add('visually-hidden');
        }

        return;
      }

      let products = grid_to_replace.querySelectorAll('.column');

      // No products left
      if (!products.length) {

        base.classList.add('pagination-ended');

        if (base.observer) {
          base.observer.disconnect();
        }

        base.hide();

        return;
      }

      // Append products
      products.forEach((product) => {

        this.grid.appendChild(product);

        product.querySelectorAll('.lazyload').forEach((image) => {
          lazySizes.loader.unveil(image);
        });

      });

      // Animations
      if (this.animations_enabled) {

        gsap.set(products, {
          opacity: 0,
          y: 30
        });

        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05
        });

      } else {

        if (typeof StampedFn.loadBadges !== "undefined") {
          StampedFn.loadBadges();
        }
      }

      // Hide pagination if last page
      if (products.length < this.page_size) {

        base.classList.add('pagination-ended');

        if (base.observer) {
          base.observer.disconnect();
        }

        base.hide();
      }
    }

    hide() {

      if (this.button) {
        this.button.style.display = 'none';
      }
    }
  }

  customElements.define('pagination-theme', Pagination);
}